import { OfferData, StoreLayoutTheme } from 'utils/types';
import { Observable } from './observable';

class StoreStateService {
  readonly storeTheme = new Observable<StoreLayoutTheme | null>();
  readonly translations = new Observable<Record<string, string>>();
  readonly sendEvent = new Observable<
    ((event: OfferData, identifier: string) => void) | undefined
  >();

  clear = () => {
    this.storeTheme.set(null);
    this.sendEvent.set(undefined);
    this.translations.set({});
  };

  setStoreTheme = (theme: StoreLayoutTheme) => this.storeTheme.set(theme);
  setTranslations = (tran: Record<string, string>) =>
    this.translations.set(tran);
  setSendEvent = (obs: ((event: OfferData, identifier: string) => void) | undefined) =>
    this.sendEvent.set(obs);
}

export const storeStateService = new StoreStateService();
